import { CommonMessage } from '@frontend/lang';
import { FormattedMessage } from 'react-intl';

import { ParallelConfirmOpenSlotsScreen } from '../confirm-open-slots-shared/parallel-confirm-open-slots-screen.component';
import useDropOffConfirmOpenSlotsParallel from './drop-off-confirm-open-slots-parallel.controller';

const ID = 'drop-off-confirm-open-slots-parallel';

const DropOffConfirmOpenSlotsParallel = () => {
    const viewProps = useDropOffConfirmOpenSlotsParallel();

    return (
        <ParallelConfirmOpenSlotsScreen
            id={ID}
            headerTitle={CommonMessage.BUTTONS.DROP_OFF}
            viewProps={viewProps}
            openSlotsLabel={
                <FormattedMessage
                    id='kiosk.wizard.drop-off-confirm-open-slots-parallel.open-slots'
                    defaultMessage='Open SLOTs'
                    description='Button to open all drop-off SLOTs for the selected collis in parallel'
                />
            }
        />
    );
};

export default DropOffConfirmOpenSlotsParallel;
